import { Component, OnInit } from '@angular/core';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { AuthService } from '../../_service/auth.service';
import { MessagingService } from '../../_service/messaging.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
    showHeader:boolean=false;username:string='';role:string;profilePic:string='';notifications:any=[];cm_access='';loginUserId:string;notifyVersionUpdate:string='false';meeting_room_access='';role_name:string;user_lead_source='';treatment_catergory_access='';is_doctor_access='';mark_as_affiliate:string;userTreatmentCat = [];showProductTab="false";
    constructor(private messageapi:MessagingService,public authapi:AuthService,private router:Router,private sharedapi:SharedService)
    {

    }

    ngOnInit(): void
    {
        this.sharedapi.getLoginchk()
        .subscribe((item:boolean) => {
            this.showHeader=item;
            if(item)
            this.getNotifications();
        });
        this.sharedapi.getNotificationPush()
        .subscribe((item:boolean) => {
            if(item && localStorage.getItem('currentUser'))
            this.getNotifications();
        });
        this.sharedapi.getUsername()
        .subscribe((item:string) => {this.username=item;});
        this.sharedapi.getProfilePic()
        .subscribe((item:string) => {this.profilePic=item;});
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.role=item;});
  
        this.sharedapi.getUserId()
        .subscribe((item:string) => {this.loginUserId=item;});
        this.sharedapi.getCMAccess()
        .subscribe((item:string) => {this.cm_access=item;});
        this.sharedapi.getLeadSourceOfUser()
        .subscribe((item:string) => {this.user_lead_source=item;});
        // this.sharedapi.getNotificationKey()
        // .subscribe((item:string) => {this.notifyVersionUpdate=item;
        //     console.log(this.notifyVersionUpdate);
        // });
        if(localStorage.getItem('currentUser'))
        {
            this.showHeader = true;
            this.getNotifications()
            this.username = localStorage.getItem('username');
            this.loginUserId = localStorage.getItem('loginuserId');
            this.role = localStorage.getItem('role');
            this.role_name = localStorage.getItem('role_name');
            this.profilePic = localStorage.getItem('profile_pic');
            this.cm_access = localStorage.getItem('CMAccess');
            this.user_lead_source = localStorage.getItem('userLeadSource');
            this.meeting_room_access = localStorage.getItem('meeting_room_access');
            this.treatment_catergory_access = localStorage.getItem('treatment_catergory_access');
            this.is_doctor_access = localStorage.getItem('is_doctor_access');
            this.mark_as_affiliate = localStorage.getItem('mark_as_affiliate');

        }else{
            this.showHeader = false;
        }

        if(this.role=='2' || this.role=='3'){
            this.userTreatmentCat = localStorage.getItem('user_catergory_access').split(',');
        }
        if(this.userTreatmentCat.includes('15') || this.userTreatmentCat.includes('16')){
            this.showProductTab = "true";
        }

    }

    async signout()
    {
        this.authapi.logout().subscribe(
        (data:any) => {
            if(data && data.status)
            {
                localStorage.clear();
                this.sharedapi.setlogin(false);
                this.router.navigate(['login']);
            }else{
              this.sharedapi.presentToast('Error Occured');
              this.router.navigate(['home']);
            }
        },
        error => {
            this.sharedapi.checkError(error);
            this.router.navigate(['home']);
        });
    }

    async getNotifications()
    {
        this.messageapi.getNotification().subscribe(
        (data:any) => {
            this.sharedapi.setNotificationPush(false);
            if(data.status)
            {
                this.notifications = data.data;
            }else{
                this.notifications = [];
            }
        },
        error => {
            this.sharedapi.checkError(error);
        });
    }

}
